import { render, staticRenderFns } from "./SuspiciousCheckIns.vue?vue&type=template&id=bbada356&scoped=true"
import script from "./SuspiciousCheckIns.vue?vue&type=script&lang=js"
export * from "./SuspiciousCheckIns.vue?vue&type=script&lang=js"
import style0 from "./SuspiciousCheckIns.vue?vue&type=style&index=0&id=bbada356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbada356",
  null
  
)

export default component.exports